<template>
    <v-row class="align-stretch" justify="start" align-content="start">
        <v-col cols="12" sm="6" md="4">
            <SingleValueChart
                :title="$t('components.ChatsPercentages.NumberOfChatsTitle')"
                :info="$t('widgetsInfo.NumberOfChats')"
                :data="stats.numberOfChats ? `${stats.numberOfChats.total}` : '-'"
                :loading="loading" :report-mode="reportMode"/>
        </v-col>
        <v-col cols="12" sm="6" md="4">
            <SingleValueChart
                :title="$t('components.ChatsPercentages.NumberOfReferralsTitle')"
                :info="$t('widgetsInfo.NumberOfReferrals')"
                :slotInfo="$t('widgetsInfo.RoiCalculator')"
                :data="stats.numberOfReferrals ? stats.numberOfReferrals.total : '-'"
                :revealTitle="$t('components.ChatsPercentages.RoiCalculatorReveal.RevealTitle')"
                :revealOpen="$t('components.ChatsPercentages.RoiCalculatorReveal.RevealOpenButton')"
                revealEvent="roi_calculator_click"
                :report-mode="reportMode"
                :loading="loading">
                    <RoiCalculator
                        v-if="stats.numberOfReferrals.total && reportMode === null"
                        :data="stats.numberOfReferrals.total"
                        :referrals="stats.numberOfReferrals.total"
                        :newPatients="stats.newPatients"/>
            </SingleValueChart>
        </v-col>
        <v-col cols="12" sm="6" md="4">
            <SingleValueChart
                :title="$t('components.ChatsPercentages.NumberOfReferralsLastMonthTitle')"
                :info="$t('widgetsInfo.NumberOfReferralsLastMonth')"
                :data="stats.numberOfReferrals ? stats.numberOfReferrals.last_month : '-'"
                :loading="loading" :report-mode="reportMode"/>
          <!--
              <SingleValueChart
                :title="$t('components.ChatsPercentages.ReferralGrowthTitle')"
                :info="$t('widgetsInfo.GrowthRate')"
                :data="stats.referralGrowth ? `${stats.referralGrowth} %` : '-'"
                :loading="loading" :report-mode="reportMode"/>
          -->
        </v-col>
    </v-row>
</template>

<script>
import SingleValueChart from '@/components/dashboard/charts/SingleValueChart';
import RoiCalculator from '@/components/dashboard/widgets/RoiCalculator';

/**
  * ChatsPercentages contains the functions to parse and format data from
  * the API to show five boxes with the total number of chats, the total
  * number of referrals, the chat conversion rate, the average time spent and
  * the referral growth rate.
  */
export default {
    name: 'ChatsPercentages',
    props: {
        loading: {
            type: Boolean,
            default: true
        },
        chatsData: {
            type: Object,
            required: true
        },
        reportMode: {
            type: String,
            required: false,
            default: null
        }
    },
    data: () => ({
        stats: {
            averageTimeSpent: 0,
            conversionRate: 0,
            numberOfChats: {
                total: 0,
                last_month: 0
            },
            numberOfReferrals: {
                total: 0,
                last_month: 0
            },
            referralGrowth: 0,
            newPatients: 0
        }
    }),
    methods: {
        updateStats(data) {
            if (data) this.stats = data;
        }
    },
    watch: {
        chatsData(value) {
            this.updateStats(value);
        }
    },
    components: { SingleValueChart, RoiCalculator }
}
</script>
